import Vue from 'vue';
import VueRouter from 'vue-router';

const Index = resolve => require(["@/views/index/index"],resolve);
const Middle = resolve => require(["@/views/middle/middle"],resolve);
const Download = resolve => require(["@/views/download/download"],resolve);

const Layout = resolve => require(["@/views/layout/layout"],resolve);
const Login = ()=>import("@/views/login/login");
const Register = ()=>import("@/views/register/register");
const RetrievePassword = ()=>import("@/views/retrievepassword/retrievepassword");
const Home = resolve => require(["@/views/home/home"], resolve);
const PublishWork = resolve => require(["@/views/publishwork/publishwork"], resolve);
const Myworks = resolve => require(["@/views/myworks/myworks"], resolve);
const WorksDetail = resolve => require(["@/views/worksdetail/worksdetail"], resolve);
const EditWorksDetail = resolve => require(["@/views/editworksdetail/editworksdetail"], resolve);
const Task = resolve => require(["@/views/task/task"], resolve);
const Mytask = resolve => require(["@/views/mytask/mytask"], resolve);
const TaskDetail = resolve => require(["@/views/taskdetail/taskdetail"], resolve);
const Clue = resolve => require(["@/views/clue/clue"], resolve);
const Submitclue = resolve => require(["@/views/submitclue/submitclue"], resolve);
const Myclue = resolve => require(["@/views/myclue/myclue"], resolve);
const ClueDetail = resolve => require(["@/views/cluedetail/cluedetail"], resolve);
const EditClueDetail = resolve => require(["@/views/editcluedetail/editcluedetail"], resolve);
const Settings = resolve => require(["@/views/settings/settings"], resolve);
const Accountset = resolve => require(["@/views/accountset/accountset"], resolve);

const Public = resolve => require(["@/views/public/public"], resolve);
const Videos = resolve => require(["@/views/videos/videos"],resolve);
const ShowTaskDetail = resolve => require(["@/views/showtaskdetail/showtaskdetail"],resolve);
const ShowArticleDetail = resolve => require(["@/views/showarticledetail/showarticledetail"],resolve);

const PrivacyPolicy = resolve => require(["@/views/privacypolicy/privacypolicy"],resolve);
const ServiceProtocol = resolve => require(["@/views/serviceprotocol/serviceprotocol"],resolve);
const TransferProtocol = resolve => require(["@/views/transferprotocol/transferprotocol"],resolve);

Vue.use(VueRouter)

export const constRoutes = [
  {
    path: "",
    redirect: "/index"
  },
  {
    path: "/",
    name: "layout",
    component: Layout,
    children: [
      {
        path: "/home",
        name: "home",
        component: Home,
        redirect: "/home/publishwork",
        meta: {
          title: "创作",
          icon: "blub"
        },
        children: [
          {
            path: "publishwork",
            name: "publishwork",
            component: PublishWork,
            meta: {
              title: "作品发布",
              parentName: "home"
            }
          },
          {
            path: "myworks",
            name: "myworks",
            component: Myworks,
            meta: {
              title: "我的作品",
              parentName: "home"
            }
          },
          {
            path: "worksdetail",
            name: "worksdetail",
            component: WorksDetail,
            meta: {
              title: "作品详情"
            }
          },
          {
            path: "editworksdetail",
            name: "editworksdetail",
            component: EditWorksDetail,
            meta: {
              title: "作品详情",
            }
          }
        ]
      },
      {
        path: "/task",
        name: "task",
        component: Task,
        redirect: "/task/mytask",
        meta: {
          title: "任务",
          icon: "task"
        },
        children: [
          {
            path: "mytask",
            name: "mytask",
            component: Mytask,
            meta: {
              title: "我的任务",
              parentName: "task"
            }
          },
          {
            path: "taskdetail",
            name: "taskdetail",
            component: TaskDetail,
            meta: {
              title: "任务详情",
            }
          }
        ]
      },
      {
        path: "/clue",
        name: "clue",
        component: Clue,
        meta: {
          title: "线索",
          icon: "clue"
        },
        children: [
          {
            path: "submitclue",
            name: "submitclue",
            component: Submitclue,
            meta: {
              title: "提交线索",
              parentName: "clue"
            }
          },
          {
            path: "myclue",
            name: "myclue",
            component: Myclue,
            meta: {
              title: "我的线索",
              parentName: "clue"
            }
          },
          {
            path: "cluedetail",
            name: "cluedetail",
            component: ClueDetail,
            meta: {
              title: "线索详情"
            }
          },
          {
            path: "editcluedetail",
            name: "editcluedetail",
            component: EditClueDetail,
            meta: {
              title: "线索详情"
            }
          }
        ]
      },
      {
        path: "/settings",
        name: "settings",
        component: Settings,
        meta: {
          title: "设置",
          icon: "setting"
        },
        children: [
          {
            path: "accountset",
            name: "accountset",
            component: Accountset,
            meta: {
              title: "账号设置",
              parentName: "settings"
            }
          }
        ]
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: {
      requiresAuth: false
    },
  },
  {
    path: "/retrievepassword",
    name: "retrievepassword",
    component: RetrievePassword,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/index",
    name: "index",
    component: Index,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/middle",
    name: "middle",
    component: Middle,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/download",
    name: "download",
    component: Download,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/privacypolicy",
    name: "privacypolicy",
    component: PrivacyPolicy,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/serviceprotocol",
    name: "serviceprotocol",
    component: ServiceProtocol,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/transferprotocol",
    name: "transferprotocol",
    component: TransferProtocol,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/public",
    name: "public",
    component: Public,
    children: [
      {
        path: "videos",
        name: "videos",
        component: Videos,
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "showtaskdetail",
        name: "showtaskdetail",
        component: ShowTaskDetail,
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "showarticledetail",
        name: "showarticledetail",
        component: ShowArticleDetail,
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
];

const createRoute = (_routes)=>{
  return new VueRouter({
    mode: "hash",
    routes: _routes
  });
};

export const hasRoute = (router, route)=>{
  let result = router.getRoutes().find(item=>route.name == item.name);
  return !!result;
}

export const addDynamicRoutes = (router, parentName, dynamicRoutes)=>{
  for(let i=0;i<dynamicRoutes.length;i++){
    router.addRoute(parentName,dynamicRoutes[i])
  }
}

const router = createRoute(constRoutes);

const originPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location){
  return originPush.call(this, location).catch(err=>err);
}

export default router;
